module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "contents"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "x2fm-ttl",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "introduction"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Four Broken Promises: Why the Tea Party Arose")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter_1"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The English Roots of American Liberty")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("American Constitutionalism and the Formation of the Secular Covenant")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-3"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Alexander Hamilton and the Broken Promise of Plain Meaning")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-4"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The Republican Party and the Broken Promise of Free Markets")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-5"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Woodrow Wilson and the Divine Right of the State")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-6"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Republicans Fail to Offer an Alternative")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-7"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 7")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Hoover, FDR, and the Broken Promise of the Fiscal Constitution")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-8"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("FDR’s Assault on Free Markets and the Constitution")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-9"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 9")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("LBJ, Richard Nixon, and the Final Destruction of the Three Promises")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-10"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 10")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The Broken Promise of Deliberative Accountability and the Rise of the Tea Party Movement")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-11"
    }
  }, [_c('p', {
    staticClass: "x2toc-chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAPTER")]), _vm._v(" 11")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2toc",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Restoring the Secular Covenant: A Tea Party America Based on the Constitution")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "endnotes"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "index"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/About_the_Author#about-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "credits"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Credits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "about-the-publisher"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/About_the_Publisher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footnotes"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Footnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Footnotes")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0